import { useState, useEffect } from "react";
import { url } from "../utils/config";
import Input from "../reusable_components/Input";
import Select from "../reusable_components/Select";
import postData from "../custom_functions/postData";
import { toast } from "react-toastify";
import currency from "../utils/currency";
import Button from "../reusable_components/Button";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";
import axios from "axios";

function SetDefaultRate(props) {
    const [formData, setFormData] = useState({});
    const [missingFields, setMissingFields] = useState([]);
    const [inputErrors, setInputErrors] = useState([]);
    const [showInputError, setShowInputError] = useState(false);
    const [loading, setLoading] = useState(true);
    const [validationError, setValidationError] = useState("");

    const requiredFields = ['rate'];
    const token = localStorage.getItem('token');

    const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    useEffect(() => {
        fetchDefaultRate();
    }, []);

    const fetchDefaultRate = async () => {
        try {
            const response = await axios.get(`${url}/default_technician_cost`, { headers });
            if (response.data) {
                setFormData({ rate: response.data.data.value });
            }
        } catch (error) {
            toast.error("Failed to fetch default rate", { autoClose: 3000 });
        } finally {
            setLoading(false);
        }
    };

    const validateRate = (value) => {
        const numValue = parseFloat(value);
        if (isNaN(numValue)) {
            return "Please enter a valid number";
        }
        if (numValue < 0) {
            return "Rate cannot be negative";
        }
        if (numValue > 99) {
            return "Rate cannot exceed 99";
        }
        if (!Number.isInteger(numValue)) {
            return "Rate must be a whole number";
        }
        return "";
    };

    async function saveDefaultRate() {
        const validationMessage = validateRate(formData.rate);
        if (validationMessage) {
            setValidationError(validationMessage);
            return;
        }

        if (
            formData.rate && formData.rate > 0 &&
            !inputErrors.includes('error')
        ) {
            try {
                const response = await axios.patch(
                    `${url}/default_technician_cost`, 
                    { defaultTechnicianCost: formData.rate },
                    { headers }
                );
                console.log(response.data);
                toast.success("Default rate updated successfully", { autoClose: 3000 });
                
                // Pass the updated rate back to the parent component
                if (props.onRateUpdate) {
                    props.onRateUpdate(Number(formData.rate));
                }
                
                props.setShowModal(false);
                if (props.reload) props.reload(1 + Math.random());
            } catch (error) {
                toast.error(error.response?.data?.message || "Failed to update default rate", { autoClose: 3000 });
            }
        } else {
            let fields = Object.keys(formData);
            let miss = [];
            if (fields.length !== requiredFields.length) {
                requiredFields.forEach(field => {
                    if (!fields.includes(field)) {
                        miss.push(field);
                    }
                });
            }
            setMissingFields(miss);
            setShowInputError(true);
        }
    }

    function updateFormData(e) {
        const { name, value } = e.target;
        var data = { ...formData };
        data[name] = value;
        setFormData(data);
        setValidationError(validateRate(value));
    }

    if (loading) {
        return (
            <div className={modalContainer}>
                <div className="bg-white rounded-lg p-4 w-1/2">
                    <div className={modalTitle}>Loading...</div>
                </div>
            </div>
        );
    }

    return (
        <div className={modalContainer}>
            <div className="bg-white rounded-lg p-4 w-1/2">
                <div className={modalTitle}>Set Default Rate</div>
                <div>
                    <div className="grid grid-cols-3">
                        <div className={label}>Default Rate/Hr</div>
                        <div className="col-span-2">
                            <Input
                                index={0}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name='rate'
                                type='number'
                                min="0"
                                max="99"
                                step="1"
                                placeHolder='Enter Default Rate per Hour'
                                value={formData.rate}
                                onChange={e => {
                                    const value = e.target.value;
                                    if (/^\d{0,3}$/.test(value)) {
                                        updateFormData(e);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex justify-between py-3 px-16 gap-8">
                    <button onClick={() => props.setShowModal(false)} className={btnCancel}>Cancel</button>
                    <Button clickHandler={() => saveDefaultRate()} className={btnOne} name={'Save'} />
                </div>
                <div className="text-red-500 font-semibold text-center">
                    {showInputError && 'Please fill all the fields as directed!'}
                    {validationError && <div className="mt-2">{validationError}</div>}
                </div>
            </div>
        </div>
    )
}

export default SetDefaultRate; 